<template>
  <div id="app">
    <section v-if="finalButtonActive" class="section abs-center has-text-centered">
      <button class="button is-primary" @click="finalButtonAction">
        {{ finalButtonText }}
      </button>
      <p v-if="inviterCode != 'linespot'" class="mt-5">
        若按鈕點擊無反應，請開啟此連結：<br>
        <a :href="linebotUrl">{{ linebotUrl }}</a>
      </p>
    </section>
    <section v-else-if="isLoading" class="section abs-center has-text-centered">
      載入中...
    </section>
    <section v-else-if="isRedirecting" class="section abs-center has-text-centered">
      正在帶您前往...
    </section>
    <section v-else-if="autoSubmit" class="section abs-center has-text-centered">
      正在綁定帳號...
    </section>
    <section v-else-if="hasSignupForm" class="section">
      <figure class="image" v-if="doctorName !== ''">
        <img :src="doctorPhoto" />
      </figure>
      <figure class="image" v-else-if="clinicPhoto !== ''">
        <img :src="clinicPhoto" />
      </figure>
      <div class="doctor-info has-text-centered">
        <p v-if="clinicName !== ''">{{ clinicName }}</p>
        <p v-if="doctorName !== ''">{{ doctorName + '醫師' }}</p>
      </div>
      <SignupForm
        :lineUserName="lineUserName"
        :hasNameField="hasNameField"
        :defaultPhone="inputPhone"
        :defaultAgree="agree"
        :isSendingCode="isSendingCode"
        :isSubmitting="isSubmitting"
        :sendVerificationCode="sendVerificationCode"
        :submitVerificationCode="submitVerificationCode"
      />
      <br>
      <p>若遇到任何問題，請聯絡<strong><a href="#" @click="openSupportOA">真人客服</a></strong></p>
    </section>
  </div>
</template>

<script>
import liff from '@line/liff';
import SignupForm from './components/SignupForm.vue';
// import VConsole from 'vconsole'

// const vConsole = new VConsole()
const hostUrl = 'https://dentco.tw';
const serverUrl = `${hostUrl}/linebot`;
const liffId = '1622774606-my6kd0On'; // '1622774606-Jw50nxYR'
// const serverUrl = 'https://www.dev.dentco.tw/linebot'; // http://127.0.0.1:8081/linebot

// const linebotUrl = 'https://line.me/R/ti/p/%40dentco';
const linebotUrl = 'https://lin.ee/oKtkgFi';
const supportLinebotUrl = 'https://line.me/R/ti/p/%40fks8160n';

export default {
  name: 'app',
  components: {
    SignupForm,
  },
  data() {
    return {
      clinicCode: '',
      clinicName: '',
      doctorCode: '',
      doctorName: '',
      doctorPhoto: '',
      clinicPhoto: '',
      lineBotId: '',
      inviterCode: '',
      lineUserName: '',
      inputPhone: '',
      agree: false,
      isSendingCode: false,
      isSubmitting: false,
      isVerified: null,
      hasForm: null,
      needReserve: null,
      finalButtonActive: false,
      autoSubmit: false,
    };
  },
  computed: {
    isLoading() {
      return this.isVerified === null && this.hasForm === null;
    },
    isRedirecting() {
      return this.isVerified === true || this.hasForm === false;
    },
    hasSignupForm() {
      return this.isVerified === false && this.hasForm === true;
    },
    hasNameField() {
      return this.isVerified === false && this.needReserve;
    },
    finalButtonText() {
      if (this.inviterCode === 'linespot') {
        return `點此預約${this.clinicName}`;
      }
      return '點此進入Dent&Co牙醫小幫手';
    },
    linebotUrl() {
      return linebotUrl;
    },
  },
  async mounted() {
    try {
      await liff.init({ liffId });
      if (!liff.isLoggedIn()) {
        const redirectUri = window.location.href;
        liff.login({ redirectUri });
      } else {
        const profile = await liff.getProfile();
        this.lineBotId = profile.userId;
        this.lineUserName = profile.displayName;
      }
    } catch (err) {
      console.log('liff init error');
    }

    this.getParams();
    if (this.hasForm) {
      this.checkLine(this.lineBotId);
    } else {
      this.addUser();
    }
  },
  methods: {
    async checkLine(lineBotId) {
      // check if the line is verified
      const response = await this.$axios.get(`${serverUrl}/api/verify/user/${lineBotId}`);
      // console.log(response.data);
      const { status, phone, agree } = response.data;
      if (status === 0) {
        this.isVerified = true;
        this.getContent();
        this.addUser();
      } else {
        this.isVerified = false;

        if (this.autoSubmit) {
          const verificationCode = await this.sendVerificationCode(this.inputPhone, this.lineUserName);
          await this.submitVerificationCode(verificationCode);
        } else {
          this.getContent();
          if (status === 1) {
            this.inputPhone = phone;
            this.agree = Boolean(agree);
          }
        }
      }
    },
    getParams() {
      const url = new URL(window.location.href);
      // LIFF v2 uri stores params in liff.state
      const liffState = url.searchParams.get('liff.state');
      const params = liffState ? new URLSearchParams(liffState) : url.searchParams;
      const p = params.get('p'); // patient code
      const c = params.get('c') || ''; // clinic code
      const d = params.get('d') || ''; // doctor code
      const hasForm = Boolean(parseInt(params.get('has_form') || '1')); // 1: show the signup form
      const needReserve = Boolean(parseInt(params.get('need_reserve') || '0')); // 1: create an empty reserve
      const phone = params.get('t') || '';
      if (phone) {
        this.autoSubmit = true;
      }

      this.inviterCode = p;
      this.clinicCode = c;
      this.doctorCode = d;
      this.hasForm = hasForm;
      this.needReserve = needReserve;
      this.inputPhone = phone;
    },
    getContent() {
      const params = { doctor_code: this.doctorCode, clinic_code: this.clinicCode };
      this.$axios.get(`${serverUrl}/api/invite/content`, { params })
        .then((res) => {
          // console.log(`content response: ${JSON.stringify(res.data)}`);
          const {
            clinicName, doctorName, doctorPhoto, clinicPhoto,
          } = res.data;
          this.clinicName = clinicName;
          this.doctorName = doctorName;
          this.doctorPhoto = doctorPhoto;
          this.clinicPhoto = clinicPhoto;
        });
    },
    async sendVerificationCode(phone, name) {
      if (!this.lineBotId || !name) {
        this.showSupportPopup('無法讀取LINE ID');
        return;
      }
      let data = {
        phone,
        name,
        line_bot_id: this.lineBotId,
      };
      if (this.autoSubmit) {
        data = { ...data, disable_sms: '1' };
      }
      try {
        this.isSendingCode = true;
        const response = await this.$axios.post(`${serverUrl}/api/verify/send_verification_code`, data);
        this.isSendingCode = false;

        if (this.autoSubmit && response.data.verification_code) {
          return response.data.verification_code;
        }

        this.$swal({
          title: '已發送簡訊驗證碼',
          type: 'info',
        });
      } catch (err) {
        this.isSendingCode = false;
        if (err.response.data) {
          const { message } = err.response.data;
          if (message === 'Incomplete parameters') {
            this.showSupportPopup('參數不完整');
          } else if (message === 'Wrong phone format') {
            this.showSupportPopup('手機格式錯誤');
          } else if (message === 'Register failed.') {
            this.showSupportPopup('註冊失敗');
          }
        } else {
          this.showSupportPopup();
        }
      }
    },
    async submitVerificationCode(verificationCode, user_name = '', user_email = '') {
      const data = {
        verification_code: verificationCode,
        line_bot_id: this.lineBotId,
      };
      // console.log(`submit data: ${JSON.stringify(data)}`);
      try {
        this.isSubmitting = true;
        await this.$axios.post(`${serverUrl}/api/verify/bind`, data);
        await this.addUser(user_name, user_email);
        this.isSubmitting = false;
      } catch (err) {
        this.isSubmitting = false;
        if (err.response.data) {
          const { message } = err.response.data;
          if (message === 'wrong verification code') {
            this.$swal({
              type: 'error',
              title: '驗證碼輸入錯誤',
            });
          } else if (message === 'line_bot_id not found') {
            this.$swal({
              type: 'error',
              title: '無此LINE ID',
            });
          } else {
            // Unkown error
            this.addUser(user_name, user_email);
          }
        } else {
          // Unkown error
          // this.showSupportPopup('綁定發生錯誤');
          this.addUser(user_name, user_email);
        }
      }
    },
    async addUser(user_name = '', user_email = '') {
      const data = {
        user_name,
        user_email,
        inviter: this.inviterCode,
        doctor_code: this.doctorCode,
        clinic_code: this.clinicCode,
        line_bot_id: this.lineBotId,
        need_reserve: this.needReserve,
      };
      // console.log(`add user data: ${JSON.stringify(data)}`);
      try {
        const response = await this.$axios.post(`${serverUrl}/api/invite/insert_line`, data);

        if (response.data.isFollower) {
          this.finalButtonAction();
        } else {
          this.openOA();
        }
        this.finalButtonActive = true;
      } catch (err) {
        console.log(err);
        if (err.response.data) {
          this.$swal({
            type: 'error',
            title: '伺服器錯誤',
            text: err.response.data.message,
          });
        }
      }
    },
    openOA() {
      window.location.href = linebotUrl;
    },
    openSupportOA() {
      liff.openWindow({
        url: supportLinebotUrl,
        external: false,
      });
    },
    async openOnlineAppointment() {
      // 0: Not open, 1: lazy, 2: live. 目前因為LINESPOT會頻繁調整，如果 ifLive = 0 也是設定成登記預約，避免民眾點擊後沒有內容
      const ifLive = await this.$axios.get(`${hostUrl}/api/ifClinicAppointmentOpne.php?clinicCode=${this.clinicCode}`);
      const method = ifLive.data === 2 ? 'live' : 'lazy';
      const channel = encodeURI('LINE熱點');
      const bookingUrl = `https://booking.dentco.tw/appointment/start/?method=${method}&type=clinic&clinicCode=${this.clinicCode}&lineBotId=${this.lineBotId}&channel=${channel}`;

      liff.openWindow({
        url: bookingUrl,
        external: false,
      });
    },
    finalButtonAction() {
      if (this.inviterCode === 'linespot') {
        this.openOnlineAppointment();
      } else {
        this.openOA();
      }
    },
    showSupportPopup(title = '無法註冊帳號') {
      this.$swal({
        title,
        type: 'error',
        text: '請聯絡真人客服',
        confirmButtonText: '加入真人客服LINE',
      }).then((result) => {
        if (result.value) {
          this.openSupportOA();
          liff.closeWindow();
        }
      });
    },
  },
};
</script>

<style src="bulma/css/bulma.css">
</style>

<style scoped>
#app {
  background-color: #f7f7f7;
  min-height: 100%;
  position: relative;
}
.section.abs-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.image {
  max-width: 200px;
  margin: 0 auto;
}
.doctor-info {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}
.doctor-info p {
  font-size: 1.25rem;
  font-weight: bold;
  color: #363636;
}
</style>
